<template>
    <Modal v-model="modelShow" title="查看联系人">
        <Form ref="memberContact" label-position="right" :model="memberContact" :label-width="80" inline>
            <FormItem label="联系人">
                <Input v-model="memberContact.name" readonly style="width:200px" />
            </FormItem>
            <FormItem label="手机号">
                <Input v-model="memberContact.mobile" readonly style="width:200px" />
            </FormItem>
            <FormItem label="邮箱">
                <Input v-model="memberContact.email" readonly style="width:200px" />
            </FormItem>
            <FormItem label="证件号码">
                <Input v-model="memberContact.identityNo" readonly style="width:200px" />
            </FormItem>
        </Form>
        <template #footer>
            <Button type="primary" @click="close">关闭</Button>
        </template>
    </Modal>
</template>

<script>
export default {
    data() {
        return {
            modelShow: false,
            memberContact: {
            }
        }
    },
    methods:{
        openModal(id){
            this.modelShow = true
            let data ={
                url:'CORE-MEMBER/messageService/contactService/queryContact',
                body:{id}
            }
            this.invoke(data).then(res=>{
                if(res){
                    this.memberContact =res
                }
            })
        },
        close(){
            this.modelShow =false
        }
    }

}
</script>

<style lang="scss" scoped>
</style>